import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';

export const DonatorBadge = () => {
    return (
        <span className="badge rounded-pill text-bg-success m-1">
            <MonetizationOnIcon />
        </span>
    )
}
